export const LOADING_START_APP = 'app-component';
export const LOADING_DASHBOARD = 'app-tableau-dashboard';
export const LOADING_PERMISSIONS = 'app-permissions';
export const LOADING_USER_INFO = 'app-user-info';
export const LOADING_USER_ADMIN = 'app-user-admin';
export const LOADING_NAVIGATION = 'app-navigation';
export const LOADING_LOGOUT = 'app-logout';
export const LOADING_LOGIN = 'app-login';
export const LOADING_GET_PROJECTS = 'app-get-projects';
